import React from 'react'

export const IconX: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M4.471 12.471L8 8.942l3.529 3.529.943-.943-3.529-3.529 3.529-3.529-.943-.943L8 7.056 4.471 3.527l-.943.943 3.529 3.529-3.529 3.529z" />
    </svg>
  )
}
